var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h2", { staticClass: "u-text-center" }, [
        _vm._v("\n    Henter enheter\n  "),
      ]),
      _vm._v(" "),
      _c("Spinner", { staticClass: "c-spinner--page" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }